<div fxLayoutAlign="center">
    <ui-kit-spinner spinnerIds="oauth"/>
</div>
